import { useNavigate } from 'react-router-dom';
import Logo from '@/components/Logo';
import { Phone } from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();

  const footerLinks = [
    { label: 'Home', path: '/' },
    { label: 'Pricing', path: '/impact-window-cost-miami' },
    { label: 'Permits', path: '/impact-window-permits-miami-dade' },
    { label: 'Case Studies', path: '/case-study-kendall-full-house' },
    { label: 'Service Areas', path: '/service-areas' },
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms', path: '/terms-of-service' }
  ];

  return (
    <footer className="border-t bg-[var(--brand-slate-900)] text-white py-12" data-testid="global-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <Logo variant="dark" size="small" className="mb-4" />
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              Professional impact window and door installation serving South Florida.
            </p>
            <div className="text-xs text-white/60">
              <p className="font-semibold text-white/80">Fully Licensed & Insured</p>
              <p>License # CGC1524851</p>
            </div>
          </div>

          <div>
            <p className="font-heading font-semibold text-sm text-white mb-3">Quick Links</p>
            <ul className="space-y-2 text-sm text-white/70">
              {footerLinks.slice(0, 4).map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="hover:text-white transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-heading font-semibold text-sm text-white mb-3">Legal & Contact</p>
            <ul className="space-y-2 text-sm text-white/70">
              {footerLinks.slice(4).map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="hover:text-white transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 space-y-3">
          <div className="flex items-center justify-center gap-2 text-sm text-white" data-testid="footer-contact-line">
            <Phone className="h-4 w-4" />
            <p>Questions? Call or text us: <a href="tel:8557847627" className="font-semibold hover:underline">855-784-SNAP</a></p>
          </div>
          <div className="text-center text-sm text-white/50">
            <p>&copy; {new Date().getFullYear()} Snap Windows. All rights reserved. Licensed & Insured General Contractor.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
